import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-12 h-12 mx-auto mb-4 rounded-full bg-red-100 flex justify-center items-center flex-shrink-0" }
const _hoisted_2 = { class: "text-gray-500 text-sm leading-5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "mt-6"
}

import {
  DialogTitle,
} from '@headlessui/vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline';
import { computed, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorModal',
  props: {
    show: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: "Error"
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
        default: "close"
    },
    cancelText: {
        type: String,
    },
    customClass: {
        type: String,
        default: 'sm:w-[480px] w-full sm:min-w-[480px] py-6 px-10'
    },
    checkIcon: {
        type: Boolean,
        default: false
    },
    noBtn : {
        type: Boolean,
        default: false
    }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props;

const show = ref<boolean>(props.show)

const close = () => {
    emit('close')
    show.value = false
}

watch(props, (val) => {
    show.value = val.show;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: __props.customClass,
    show: show.value,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (show.value = false))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ExclamationCircleIcon), { class: "w-5 h-5 text-red-600 mx-auto" })
      ]),
      _createVNode(_unref(DialogTitle), {
        as: "p",
        class: "text-xl font-bold text-neutral-900"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (__props.content)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.content), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "content")
      ]),
      (!__props.noBtn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(ButtonComponent, {
              size: "large",
              btnWidth: "primary rounded-lg",
              customClass: "primary mx-auto",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.actionText), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["customClass", "show"]))
}
}

})